<app-loader></app-loader>

<!-- Estilos para el sidenav -->
<style>
  .app-sidenav a.nav-link {
    width: 100%;
    display: block;
  }
</style>

<mat-drawer-container class="app-sidenav-container" autosize>
  <mat-drawer #drawer class="app-sidenav" mode="over">
    <!-- <mat-toolbar color="primary">
      <span class="toolbar-spacer"></span>
      <button mat-icon-button aria-label="Cerrar menu" (click)="drawer.toggle()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar> -->
    <div class="sidenav-header">
      <div class="header-items mb-4 pt-4">
        <mat-icon class="back-arrow-icon" (click)="drawer.toggle()">arrow_back</mat-icon>
        <span class="welcome-text">Bienvenido</span>
        <span class="user-name" *ngIf="authService.isLoggedIn() && authService.userProfile && authService.userProfile.email" style="font-size: 14px;">
          {{authService.userProfile.email}}
        </span>
        <span class="user-name" *ngIf="!authService.isLoggedIn()" style="font-size: 14px;">
          Inicie sesión o registrese
        </span>
      </div>
    </div>

    <div class="pl-4 pr-4 mt-4">
      <div class="sidenav-items-container" *ngFor="let item of getFilteredSidenavItems()" [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <span>{{item.label}}</span>
      </div>

      <!-- Dropdown "Mis herramientas" para mobile (solo si tiene acceso) -->
      <div class="doctor-tools-dropdown" *ngIf="hasDoctorToolsAccess()">
        <div class="dropdown-header" (click)="toggleDoctorToolsDropdown()">
          <span>Mis herramientas</span>
          <mat-icon [class.rotated]="isDoctorToolsDropdownOpen">{{ isDoctorToolsDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div class="dropdown-content" *ngIf="isDoctorToolsDropdownOpen">
          <div class="dropdown-item" *ngIf="hasDoctorRole()" (click)="navigateToDoctorTab('recomendaciones')">
            <mat-icon>description_outlined</mat-icon>
            <span>Recomendaciones</span>
          </div>
          <div class="dropdown-item" *ngIf="hasPatientSearchRole()" (click)="navigateToDoctorTab('busqueda')">
            <mat-icon>person_search</mat-icon>
            <span>Búsqueda de pacientes</span>
          </div>
          <div class="dropdown-item" *ngIf="hasDemographicsRole()" (click)="navigateToDoctorTab('demograficos')">
            <mat-icon>group</mat-icon>
            <span>Demográficos</span>
          </div>
          <div class="dropdown-item" *ngIf="hasDeleteRole()" (click)="navigateToDoctorTab('borrar')">
            <mat-icon>delete_outline</mat-icon>
            <span>Borrar</span>
          </div>
        </div>
      </div>
    </div>

    <div class="logout-login-btn-container pl-4 pr-4">
      <button *ngIf="authService.isLoggedIn()" class="logout-btn p-3" (click)="authService.logout()">Cerrar sesión</button>
      <div *ngIf="!authService.isLoggedIn()" class="login-register-buttons">
        <button class="logout-btn p-3 mb-2" routerLink="/login">Iniciar sesión</button>
        <button class="logout-btn p-3" routerLink="/register">Registrarse</button>
      </div>
    </div>
    <!-- <prgov-header [inSideNav]="true" (closeSidenav)="drawer.close()" (openSidenav)="drawer.open()"></prgov-header> -->
  </mat-drawer>
  <div class="app-sidenav-content">


    <prgov-header (closeSidenav)="drawer.close()" (openSidenav)="drawer.open()"></prgov-header>

    <div class="app-main-content">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
      <button class="button-scroll-up" *ngIf="isShow" (click)="gotoTop()"><mat-icon>arrow_upward</mat-icon></button>
    </div>
    <!-- <div class="spacer" *ngIf="!isTwoFactorRoute"></div> -->
    <prgov-footer></prgov-footer>
  </div>
</mat-drawer-container>




<ng-container *ngIf="dynamicFormService.formLoaderIsVisible">
    <div class="component-loader fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut">
    </div>
</ng-container>

<ng-container  *ngIf="(transService.fileToLoad || transactionRequirementeService.fileToLoad) && transService.RequirementTypeName == 'PdfForm'
&& (!transactionService.itemToEdit.Radicated || transService.IsFlagedForVerification)">
  <pdf-viewer class="fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut" [validateForm]="true">
  </pdf-viewer>
</ng-container>


<ng-container *ngIf="(transService.fileToLoad || transactionRequirementeService.fileToLoad)
&& ( (transService.RequirementTypeName != 'PdfForm') || (transService.RequirementTypeName == 'PdfForm' && transactionService.itemToEdit.Radicated  && !transService.IsFlagedForVerification )) ">
    <document-viewer class="fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut">
    </document-viewer>
</ng-container>


<ng-container *ngIf="paymentService.paymentFormIsVisible">
  <payment-form class="fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut">
  </payment-form>
</ng-container>

<ng-container *ngIf="paymentService.paymentPlanFormIsVisible">
  <payment-plan-form class="fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut">
  </payment-plan-form>
</ng-container>

<ng-container *ngIf="termsAndConditionsService.termsIsVisible">
    <terms-and-conditions class="fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut">
    </terms-and-conditions>
</ng-container>

<ng-container *ngIf="mainSearchService.mainSearchIsVisible">
    <main-search-results class="fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut">
    </main-search-results>
</ng-container>

<ng-container *ngIf="requirementReviewService.requirementReviewFormIsVisible">
    <requirement-review class="fadeInUp1" when-visible="animateElementIn" when-not-visible="animateElementOut">
    </requirement-review>
</ng-container>

<!-- Chat window
<button class="open-button rounded-circle shadow-sm" onclick="openChatWin()"><mat-icon>chat</mat-icon><span class="sr-only">o</span></button>
<div id="chat-popup" class="shadow hide">
  <div class="chat-popup-head border-bottom d-flex justify-content-between align-items-center p-1"><strong class="ml-2">CSI Virtual Bot</strong><button mat-button class="auto-width" onclick="closeChatWin()"><mat-icon>close</mat-icon></button></div>
  <iframe src='https://webchat.botframework.com/embed/csiqna-bot?s=9cWdzyWPLdo.jP6J5wrJvjiTiQSv1JQ_DbrW3bvEQ6ynAGPYB9vTA0Q'  style='min-width: 200px; width: 100%; min-height: 400px;'></iframe>
</div>-->
